module.exports = {"id":"215056","name":"Carlos Carbonero","rating":"73","photo":"./data/images/photos/3/215056.png","club":{"name":"Cortuluá","logo":"./data/images/clubs/Cortulua.png"},"positions":["MC","AD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CarlosCarbonero0.json
// module id = 713
// module chunks = 0